import request from '@/utils/request'

const key = 'account'
const key2 = 'designer_account'
const key3 = 'user'
// 查询账号列表
export function fetchAccountList(params) {
  return request({
    url: `/platform/${key}`,
    method: 'get',
    params: {
      ...params
    }
  })
}

// 新增账号
export function createAccount(data) {
  return request({
    url: `/platform/${key}`,
    method: 'post',
    data
  })
}

// 重置密码
export function editAccountPsw(id, data) {
  return request({
    url: `/platform/${key}/password/${id}`,
    method: 'post',
    data
  })
}

// 编辑账号
export function updateAccount(id, data) {
  return request({
    url: `/platform/${key}/${id}`,
    method: 'post',
    data
  })
}

// 查询详情
export function fetchStoreDetail(id) {
  return request({
    url: `/admin/${key}/${id}`,
    method: 'get'
  })
}

// 管理平台运营账号 状态 / 使用者
export function managePlatformAccount(data) {
  console.log(data)
  return request({
    url: `/platform/${key}/add_edit`,
    method: 'post',
    data
  })
}

// 修改平台账号密码
export function editPlatformAccountPassword(data) {
  return request({
    url: `/platform/${key}/edit_pwd`,
    method: 'post',
    data
  })
}

// 获取服务人员账号列表
export function fetchDesignerAccountList(params) {
  return request({
    url: `/platform/${key2}/index`,
    method: 'get',
    params: {
      ...params
    }
  })
}

// 管理平台账号 状态 / 使用者
export function manageDesignerAccount(data) {
  console.log(data)
  return request({
    url: `/platform/${key2}/add_edit`,
    method: 'post',
    data
  })
}

// 更新服务人员账号状态
export function updateDesignerAccount(id, data) {
  return request({
    url: `/platform/${key2}/add_edit`,
    method: 'post',
    data
  })
}

// 更新服务人员密码
export function editDesignerAccountPassword(data) {
  return request({
    url: `/platform/${key2}/edit_pwd`,
    method: 'post',
    data
  })
}

// 修改
export function updatePlatformAccount(id, data) {
  return request({
    url: `/admin/${key}/${id}`,
    method: 'post',
    data
  })
}

// 获取用户账号列表
export function fetchUserList(params) {
  return request({
    url: `/platform/${key3}`,
    method: 'get',
    params: {
      ...params
    }
  })
}

// 修改产品状态
export function updateStoreStatus(id, data) {
  return request({
    url: `/admin/${key}/status/${id}`,
    method: 'post',
    data
  })
}

// 批量禁用/启用
export function updateMultiStatus(data) {
  return request({
    url: `/platform/${key}/status`,
    method: 'post',
    data
  })
}
